module.exports = "/_next/static/images/residencialProduto-d08a2debdca342aa3ca57c91d549e9e9.svg";